<template>
  <div class="container">
    <div class="row py-3 justify-content-center align-items-center flex-column">
      <div class="col-12 px-0">
        <dfp-slot
          path="/22777916944/RTBGo_Web_VOD_Banner_Side_300x900"
          :size="[300, 900]"
          id="div-gpt-ad-1751442522790-0"
          style="margin:0 auto;"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BillboardSide",
  props: ["path", "size", "idName"],
};
</script>

<style scoped>
.stickyads {
  position: sticky;
  bottom: 0;
  margin: 0 auto;
  background: red;
}
.showdiv {
  display: none;
}
@media (min-width: 1000px) {
  .showdiv {
    display: flex;
  }
}
</style>
